import { render } from "./SalesDestinationEdit.vue?vue&type=template&id=11012d50&scoped=true&ts=true"
import script from "./SalesDestinationEdit.vue?vue&type=script&lang=ts"
export * from "./SalesDestinationEdit.vue?vue&type=script&lang=ts"

import "./SalesDestinationEdit.vue?vue&type=style&index=0&id=11012d50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11012d50"]])

export default __exports__